import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {UrlSharedValueObject} from '../../shared/ValueObjects/UrlSharedValueObject.js'

export class GetFaqsForUrlSearchRequest extends ValueObject {
  #targetUrl

  constructor({targetUrl}) {
    super()
    this.#targetUrl = targetUrl
  }

  static validate({targetUrl}) {
    if (!targetUrl) {
      throw InvalidParamsSharedError.create('[GetFaqsForUrlSearchRequest.validate] targetUrl is required')
    }
  }

  static create({config, targetUrl}) {
    GetFaqsForUrlSearchRequest.validate({targetUrl})
    return new GetFaqsForUrlSearchRequest({
      targetUrl: UrlSharedValueObject.createWithSanitize({config, url: targetUrl})
    })
  }

  get value() {
    return {
      targetUrl: this.#targetUrl.url
    }
  }

  toJSON() {
    return {
      targetUrl: this.#targetUrl.url
    }
  }
}
